<template>
  <div>
    <material-card>
      <v-toolbar slot="header" color="primary">
        <v-toolbar-title>QRCodes</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          outlined
          color="white"
          v-if="loggedUser.role === '1'"
          @click="qrCodesDialog = true"
          :disabled="!canRequestQrcodes"
        >Request QRCodes</v-btn>
      </v-toolbar>
      <v-data-table
        :headers="qrcodesTable.headers"
        :items="qrcodesTable.data"
        :options.sync="qrcodesTableOptions"
        :server-items-length="qrcodesTable.total"
        :loading="qrcodesTable.loading"
        dense
        class="elevation-1"
        :footer-props="{
                'items-per-page-options': [5, 10, 15, 20, 30, 50]
              }"
        :items-per-page="5"
      >
      <template v-slot:body.append>
        <tr>
          <td></td>
          <td><strong>Totals:</strong></td>
          <td>
            {{qrcodesTable.totals.total}}
          </td>
          <td>
            {{qrcodesTable.totals.total_available}}
          </td>
          <td>
            {{qrcodesTable.totals.total_scanned}}
          </td>
          <td>
            {{qrcodesTable.totals.total_used}}
          </td>
        </tr>
      </template>
        <template slot="headerCell" slot-scope="{ header }">
          <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
        </template>
        <template v-if="canRequestQrcodes" v-slot:item.client_name="{ item }">
          <a :href="item.link" dark>{{ item.client_name }}</a>
        </template>
      </v-data-table>
    </material-card>

    <v-dialog v-model="qrCodesDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>Request QRcode</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-form ref="qrcodeRequest" v-model="qrCodeRequest.valid">
            <v-select
              v-model="qrCodeRequest.qrcodeMerchant"
              :items="campaignMerchants"
              item-value="campaign_id"
              item-text="name"
              label="Merchant"
              return-object
              :rules="[v => !!v || 'Merchant is required']"
            ></v-select>
            <v-text-field
              v-model="qrCodeRequest.qrcodeAmount"
              type="number"
              min="0"
              label="Number of QRCodes"
              :rules="[v => (v && v.length > 0) || 'Field is required']"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary darken-1" outlined @click="qrCodesDialog = false">Cancel</v-btn>
          <v-btn color="primary darken-1" @click="requestQrcodes(); qrCodesDialog = false">Request qrcodes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import apiService from '@/services'
import moment from 'moment'

export default {
  props: {
    campaignMerchants: {
      type: Array,
      default () {
        return []
      }
    },
    canRequestQrcodes: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.getQrcodes(this.$route.params.campaignId)
  },
  watch: {
    qrcodesTableOptions: {
      handler () {
        this.getQrcodes(this.$route.params.campaignId)
      },
      deep: true
    }
  },
  data () {
    return {
      qrcodesTable: {
        headers: [
          {
            text: 'Client',
            value: 'client_name',
            sortable: true
          },
          {
            text: 'Merchant',
            value: 'merchant_name',
            sortable: true
          },
          {
            text: 'Total',
            value: 'totalQrcodes',
            sortable: true
          },
          {
            text: 'Available',
            value: 'available',
            sortable: true
          },
          {
            text: 'Scanned',
            value: 'scanned',
            sortable: true
          },
          {
            text: 'Used',
            value: 'used',
            sortable: true
          },
          {
            text: 'Creation date',
            value: 'formattedDate',
            sortable: true
          }
        ],
        options: {},
        data: [],
        total: 0,
        loading: true,
        totals: {}
      },
      qrcodesTableOptions: {},
      qrCodesDialog: false,
      qrCodeRequest: {
        valid: true,
        qrcodeMerchant: '',
        qrcodeAmount: null
      }
    }
  },
  computed: {
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    }
  },
  methods: {

    /**
     * Get qcodes of the Merchant
     */
    getQrcodes (campaignId) {
      this.qrcodesTable.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.qrcodesTableOptions

      let filter = {}
      filter.sort_by = sortBy[0] || 'campaign_name'
      filter.descending = sortDesc[0]
      filter.page = page
      filter.limit = itemsPerPage
      filter.id = campaignId
      filter.campaign_id = campaignId

      // Get QRCodes
      apiService
        .getQrcodes(filter) // Get all qrcodes
        .then(response => {
          const data = response.data[0]
          this.qrcodesTable.totals = response.data[1][0]

          // Format dates to DD-MM-YYYY HH:mm
          data.map(val => {
            val.formattedDate = moment(val.date).format('DD-MM-YYYY HH:mm')
          })
          this.qrcodesTable.data = data
          this.qrcodesTable.data.map(i => {
            i.totalQrcodes = i.available + i.used
            return i
          })

          // If qrcodes are present usm them by type to obtain subtotals
          // Totals are displayed under the qrcodes table
          // if (data.length > 0) {
          //   this.qrcodesTable.totals = data.reduce(function (a, b) {
          //     return {
          //       available: a.available + b.available,
          //       used: a.used + b.used,
          //       scanned: a.scanned + b.scanned,
          //       totalQrcodes: a.totalQrcodes + b.totalQrcodes
          //     }
          //   })
          // }

          this.qrcodesTable.total = response.data.length || 0

          this.qrcodesTable.loading = false
        })
        .catch((error) => {
          this.qrcodesTable.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error.message
          })
        })
    },

    /**
     * Request QRCode for merchant
     */
    requestQrcodes () {
      let data = {}
      if (this.$refs.qrcodeRequest.validate()) {
        data.campaign_id = this.$route.params.campaignId
        data.merchant_id = this.qrCodeRequest.qrcodeMerchant.id
        data.client_id = this.qrCodeRequest.qrcodeMerchant.id
        data.number_of_qrcode = parseInt(this.qrCodeRequest.qrcodeAmount)

        apiService
          .requestQrcodes(data)
          .then((response) => {
            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              text: `QRCodes requested succesfully, they will be available as soon as possible.`
            })
          })
          .catch((error) => {
            console.log('ERROR', error)
            if (error.status === 409) {
              this.$store.dispatch('alert/showSnackbar', {
                color: 'error',
                text: `Campaign is terminated.`
              })
            } else {
              this.$store.dispatch('alert/showSnackbar', {
                color: 'error',
                text: `Error: ${error.response.data.detail}`
              })
            }
          })
      } else {
        console.log('Form not valid')
      }
    }
  }
}
</script>
